import React from 'react';
import Icon from '@ant-design/icons';

const CustomIcon = React.forwardRef((props: any, _) => (
  <Icon component={props.svg} className={props.className} />
));

export default CustomIcon;
